// import React, { useEffect, useState } from "react";
// import { countries } from "countries-list";
// import { useDispatch, useSelector } from "react-redux";
// import { saveShippingInfo } from "../../redux/slices/cartSlice";
// import { useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async";

// const Shipping = () => {
//   const countriesList = Object.values(countries);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [address, setAddress] = useState("");
//   const [city, setCity] = useState("");
//   const [region, setRegion] = useState("");
//   const [zipCode, setZipCode] = useState("");
//   const [phoneNo, setPhoneNo] = useState("");
//   const [country, setCountry] = useState("");

//   const { shippingInfo } = useSelector((state) => state.cart);

//   useEffect(() => {
//     if (shippingInfo) {
//       setAddress(shippingInfo.address || "");
//       setCity(shippingInfo.city || "");
//       setRegion(shippingInfo.region || "");
//       setZipCode(shippingInfo.zipCode || "");
//       setPhoneNo(shippingInfo.phoneNo || "");
//       setCountry(shippingInfo.country || "");
//     }
//   }, [shippingInfo]);

//   const submitHandler = (e) => {
//     e.preventDefault();
//     dispatch(
//       saveShippingInfo({ address, city, region, zipCode, phoneNo, country })
//     );
//     navigate("/confirm_order");
//   };

//   return (
//     <>
//      <Helmet>
//         <title>Shipping Info</title>
//         <meta name="robots" content="noindex, nofollow" />
//       </Helmet>

//       <section className="max-w-2xl mx-auto md:mt-40 mt-16 px-6 py-12 bg-[#f5f3ea] rounded-md shadow-md font-sourcesans">
//         <h2 className="text-3xl font-playfair text-[#BC3F4A] mb-6 text-center">
//           Shipping Info
//         </h2>

//         <form onSubmit={submitHandler} className="space-y-6 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-sm">
//           {/* Address */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">Address</label>
//             <input
//               type="text"
//               required
//               value={address}
//               onChange={(e) => setAddress(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             />
//           </div>

//           {/* City */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">City</label>
//             <input
//               type="text"
//               required
//               value={city}
//               onChange={(e) => setCity(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             />
//           </div>

//           {/* State/Region */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">State / Region</label>
//             <input
//               type="text"
//               required
//               value={region}
//               onChange={(e) => setRegion(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             />
//           </div>

//           {/* Phone Number */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">Phone Number</label>
//             <input
//               type="tel"
//               required
//               value={phoneNo}
//               onChange={(e) => setPhoneNo(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             />
//           </div>

//           {/* Zip Code */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">Zip Code</label>
//             <input
//               type="text"
//               required
//               value={zipCode}
//               onChange={(e) => setZipCode(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             />
//           </div>

//           {/* Country */}
//           <div>
//             <label className="block text-sm text-[#1c1917] mb-1">Country</label>
//             <select
//               required
//               value={country}
//               onChange={(e) => setCountry(e.target.value)}
//               className="w-full px-4 py-3 border border-[#8a4b32] bg-white/70 text-[#1c1917] rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
//             >
//               <option value="">Select Country</option>
//               {countriesList.map((c) => (
//                 <option key={c.name} value={c.name}>
//                   {c.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Submit */}
//           <button
//             type="submit"
//             className="w-full bg-[#BC3F4A] hover:bg-[#a3323b] text-white py-3 px-6 rounded-md text-sm font-playfair focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition"
//           >
//             CONTINUE
//           </button>
//         </form>
//       </section>
//     </>
//   );
// };

// export default Shipping;

import React, { useEffect, useState } from "react";
import { countries } from "countries-list";
import { useDispatch, useSelector } from "react-redux";
import { saveShippingInfo } from "../../redux/slices/cartSlice";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useStripeCheckoutSessionMutation } from "../../redux/api/orderApi";
import { caluclateOrderCost } from "../../helpers/helpers";
import toast from "react-hot-toast";
import { Loader2 } from "lucide-react";

// Sorted country list — usable as-is from countries-list
const COUNTRIES = Object.values(countries).sort((a, b) =>
  a.name.localeCompare(b.name)
);

const Field = ({ label, id, error, children }) => (
  <div>
    <label
      htmlFor={id}
      className="block text-xs font-medium text-stone-500 uppercase tracking-wide mb-1.5"
    >
      {label}
    </label>
    {children}
    {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
  </div>
);

const inputClass =
  "w-full px-4 py-3 border border-stone-300 bg-white rounded-lg text-[#1c1917] placeholder-stone-400 focus:outline-none focus:ring-2 focus:ring-[#BC3F4A]/40 focus:border-[#BC3F4A] transition text-sm";

const Shipping = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { shippingInfo, cartItems } = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [country, setCountry] = useState("");

  const [
    stripeCheckoutSession,
    { data: checkoutData, error: checkoutError, isLoading },
  ] = useStripeCheckoutSessionMutation();

  // Pre-fill from saved shipping info
  useEffect(() => {
    if (shippingInfo) {
      setAddress(shippingInfo.address || "");
      setCity(shippingInfo.city || "");
      setRegion(shippingInfo.region || "");
      setZipCode(shippingInfo.zipCode || "");
      setPhoneNo(shippingInfo.phoneNo || "");
      setCountry(shippingInfo.country || "");
    }
  }, [shippingInfo]);

  // Redirect to Stripe when session URL is ready
  useEffect(() => {
    if (checkoutData?.url) {
      window.location.href = checkoutData.url;
    }
  }, [checkoutData]);

  useEffect(() => {
    if (checkoutError) {
      toast.error(
        checkoutError?.data?.message ||
          "Could not start checkout. Please try again."
      );
    }
  }, [checkoutError]);

  // Guard — redirect to cart if empty
  useEffect(() => {
    if (cartItems.length === 0) navigate("/cart");
  }, [cartItems, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();

    const shipping = { address, city, region, zipCode, phoneNo, country, email };
    dispatch(saveShippingInfo(shipping));

    const { itemsPrice, shippingPrice, taxPrice, totalPrice } =
      caluclateOrderCost(cartItems);

    stripeCheckoutSession({
      shippingInfo: shipping,
      orderItems: cartItems,
      itemsPrice,
      shippingAmount: shippingPrice,
      taxAmount: taxPrice,
      totalAmount: totalPrice,
      guestEmail: user ? undefined : email,
    });
  };

  return (
    <>
      <Helmet>
        <title>Shipping — Sanguine Accent</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-[#f5f3ea] pt-28 md:pt-44 pb-20 px-4 sm:px-6 font-sourcesans">
        <div className="max-w-lg mx-auto">
          {/* Progress indicator */}
          <div className="flex items-center gap-2 mb-8 text-xs text-stone-400">
            <span
              onClick={() => navigate("/cart")}
              className="text-[#BC3F4A] font-medium cursor-pointer hover:underline"
            >
              Bag
            </span>
            <span>→</span>
            <span className="text-[#1c1917] font-medium">Shipping</span>
            <span>→</span>
            <span>Payment</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-playfair text-[#1c1917] mb-6">
            Shipping details
          </h1>

          <form onSubmit={submitHandler} className="space-y-4">
            <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-6 space-y-4">
             
              {!user && (
                <Field label="Email address" id="email">
                  <input
                    id="email"
                    type="email"
                    required
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={inputClass}
                    placeholder="you@example.com"
                  />
                </Field>
              )}

              <Field label="Street address" id="address">
                <input
                  id="address"
                  type="text"
                  required
                  autoComplete="street-address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  className={inputClass}
                  placeholder="123 Main St"
                />
              </Field>
              <div className="grid grid-cols-2 gap-4">
                <Field label="City" id="city">
                  <input
                    id="city"
                    type="text"
                    required
                    autoComplete="address-level2"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className={inputClass}
                    placeholder="New York"
                  />
                </Field>

                <Field label="State / Region" id="region">
                  <input
                    id="region"
                    type="text"
                    required
                    autoComplete="address-level1"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    className={inputClass}
                    placeholder="NY"
                  />
                </Field>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Field label="ZIP / Postal code" id="zipCode">
                  <input
                    id="zipCode"
                    type="text"
                    required
                    autoComplete="postal-code"
                    value={zipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                    className={inputClass}
                    placeholder="10001"
                  />
                </Field>

                <Field label="Phone number" id="phoneNo">
                  <input
                    id="phoneNo"
                    type="tel"
                    required
                    autoComplete="tel"
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)}
                    className={inputClass}
                    placeholder="+1 555 000 0000"
                  />
                </Field>
              </div>
              <Field label="Country" id="country">
                <select
                  id="country"
                  required
                  autoComplete="country-name"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  className={inputClass}
                >
                  <option value="">Select country…</option>
                  {COUNTRIES.map((c) => (
                    <option key={c.name} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </Field>
            </div>

            {/* Order mini-summary */}
            <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-4">
              <p className="text-xs text-stone-500 mb-3 uppercase tracking-wide font-medium">
                Order summary
              </p>
              <div className="space-y-2">
                {cartItems.map((item) => (
                  <div
                    key={item.product}
                    className="flex items-center justify-between text-sm"
                  >
                    <div className="flex items-center gap-2 min-w-0">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-8 h-8 object-cover rounded shrink-0"
                      />
                      <span className="text-stone-700 truncate">
                        {item.name}
                      </span>
                      <span className="text-stone-400 shrink-0">
                        × {item.quantity}
                      </span>
                    </div>
                    <span className="text-stone-700 shrink-0 ml-2">
                      ${(item.price * item.quantity).toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-t border-stone-100 mt-3 pt-3 flex justify-between text-sm font-medium text-[#1c1917]">
                <span>Total</span>
                <span className="text-[#BC3F4A]">
                  $
                  {cartItems
                    .reduce((acc, i) => acc + i.price * i.quantity, 0)
                    .toFixed(2)}
                </span>
              </div>
            </div>

            <p className="text-center text-xs text-stone-400">
              70% of your purchase goes directly to people serving in Ukraine.
            </p>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3.5 bg-[#BC3F4A] hover:bg-[#a3323b] disabled:opacity-60 disabled:cursor-not-allowed text-white font-playfair text-base rounded-lg transition focus:outline-none focus:ring-2 focus:ring-[#BC3F4A] focus:ring-offset-2 flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <Loader2
                    className="w-4 h-4 animate-spin"
                    aria-hidden="true"
                  />
                  Opening secure checkout…
                </>
              ) : (
                "Continue to Payment →"
              )}
            </button>

            <p className="text-center text-xs text-stone-400">
              You'll be redirected to Stripe's secure payment page.
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default Shipping;
